import React, {Component} from 'react';
import Autocomplete from "@material-ui/lab/Autocomplete";
import request from "../../../../Services/API/Requests";
import {TextField} from "@material-ui/core";
import {valueHandlerAutoComplete} from "../../FormDynamic/Utils/valueHandler";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/styles";

const styles = () => ({
    fieldWrapper: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        position: 'relative'
    },
    fieldLabel: {
        flex: 'none',
        display: 'block',
    },
    formControl: {
        minWidth: 'auto'
    },
    inputRoot: {
        '&[class*="MuiOutlinedInput-root"]': {
            padding: '2px 0',
            '& $input': {
                padding: '2px 4px !important',
            },
        },
    },
    option: {
        minHeight: 2,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        cursor: 'pointer',
        paddingTop: 1,
        boxSizing: 'border-box',
        outline: '0',
        WebkitTapHighlightColor: 'transparent',
        paddingBottom: 2,
        paddingLeft: 16,
        paddingRight: 16,
    },
    popupIndicator: {
      marginRight: '-8px'
    },
    paper: {
        display: 'none'
    },
    clearIndicator: {
        display: 'none',
    },
    tag: {
        height: '24px'
    },
});

class TypeAutoCompleteRemote extends Component {
    constructor(props) {
        super(props);
        this.state = {
            options: []
        }
    }


    async componentDidMount() {
        const {element, options} = this.props;
        let newSuggestions = options ? options : [];
        if (element.source) {
            const suggestions = await listRequestWrapper(element.source);
            suggestions.forEach(source => {
                newSuggestions.push({value: source.id, label: source.id})
            });
        }
        this.setState({options: newSuggestions})
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {options} = this.props;
        const {options: prevOptions} = prevProps;
        if (options !== prevOptions) {
            this.setState({options})
        }
    }


    render() {
        const {options} = this.state;
        const {classes, element, path, values, onChangeAutoComplete} = this.props;
        let pathToValue = path ? path : element.name;
        return (
            <Autocomplete
                onChange={(event, value) => onChangeAutoComplete(value ? value.value : '', element.name, pathToValue)}
                value={valueHandlerAutoComplete(values, pathToValue, options)}
                name={element.name}
                disabled={element.disabled}
                getOptionLabel={option => option.label}
                options={options}
                classes={{
                    inputRoot: classes.inputRoot,
                    clearIndicator: classes.clearIndicator,
                    popupIndicator: classes.popupIndicator,
                    option: classes.option,
                    //paper: props.classes.paper,
                    //tag: props.classes.tag,
                }}
                renderInput={params => (
                    <TextField
                        {...params}
                        variant="outlined"
                        fullWidth
                        InputProps={{
                        ...params.InputProps,
                    }}
                        className={'horizontal-fields-table'}
                    />)}
            />
        );
    }
}

//options should be in format [{value: "", label: ""}]
TypeAutoCompleteRemote.propTypes = {
    onChangeAutoComplete: PropTypes.func.isRequired,
    element: PropTypes.object.isRequired,
    values: PropTypes.any.isRequired,
    path: PropTypes.string.isRequired,
    options: PropTypes.array
};

export default withStyles(styles)(TypeAutoCompleteRemote);

const listRequestWrapper = async (entity) => {

    if (entity) {
        try {
            const response = await request({
                url: 'list/getData',
                method: "POST",
                data: {
                    id: entity + 'DefaultList',
                    pageSize: 9999,
                }
            });
            return response.content
        } catch (e) {
            console.log(e);
            return [];
        }
    }
};